var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightLogoSubtract(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18.9199,
    height: 18.9199,
    viewBox: "0 0 18.9199 18.9199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M9.45996 0C14.6846 0 18.9198 4.23535 18.9199 9.45996C18.9199 14.6847 14.6847 18.9199 9.45996 18.9199C4.23535 18.9198 0 14.6846 0 9.45996C0.000111324 4.23542 4.23542 0.000111327 9.45996 0ZM4.9707 13.9502H13.9502V4.95215L4.9707 13.9502Z",
    fill: "#424952"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightLogoSubtract);
export default __webpack_public_path__ + "static/media/light-logo-subtract.cb9381a963c28423eb293997610bfd11.svg";
export { ForwardRef as ReactComponent };